export default "__VITE_ASSET__uGh6Ne0S__"